<script>
    // ICP A2A 付款結果頁
    // 付款完成後 OPAPP 重新開啟此頁面，並在 URL Query Params 帶入交易結果：
    //   TradeResultCode: 1=執行成功, 4=取消或失敗
    //   TradeResultMsg: 交易結果說明文字
    import { layoutOption, queryStr } from '../store/inapp-store'
    import { Modal, Loader } from '../components';
    import { onMount } from 'svelte';

    $layoutOption.showBanner = false
    $layoutOption.showCarousel = false

    const urlParams = new URLSearchParams(window.location.search)
    const tradeResultCode = urlParams.get('TradeResultCode')
    const tradeResultMsg = urlParams.get('TradeResultMsg')

    let modal = {
        title : '登記借杯',
        message : '',
        type: 'alert'
    }

    let isOpen = false
    let isBlock = true
    let loader = { content : '' }

    function goHome() {
        const params = new URLSearchParams(($queryStr || '').replace(/^\?/, ''))
        ;['state', 'TradeResultCode', 'TradeResultMsg', 'EncData'].forEach(k => params.delete(k))
        const qs = params.toString()
        location.href = '/home' + (qs ? '?' + qs : '')
    }

    onMount(() => {
        isBlock = false

        if (tradeResultCode === '1') {
            location.href = 'register-result'
            return
        }

        if (tradeResultMsg === '交易已取消') {
            modal.message = '交易取消'
        } else {
            modal.message = '發生錯誤，請先查詢紀錄，以確認是否訂單成立，或是稍後進行重試'
        }
        isOpen = true
    })

</script>

<Loader {loader} {isBlock}></Loader>
<Modal {modal} {isOpen} on:closeModal={goHome}></Modal>
